module.exports = __webpack_public_path__ + "static/media/spidermanHero.7581d29b.png";